import React, { Component } from 'react';

import {
    View,
    StyleSheet,
    ScrollView
} from 'react-native';
import {
    JDTouchable,
    JDText
} from '@jdreact/jdreact-core-lib';

import { pt, px } from '../../common/utils';

export default class TabList extends Component {
    static defaultProps = {
        // issueList: ["今天8月20日,2018-08-20,true","明天8月21日,2018-08-21,false","周三8月22日,2018-08-22,false","周四8月23日,2018-08-23,false"],
        // theDate: '2018-08-20'
    }

    render() {
        const { issueList, theDate, changeDate } = this.props;

        return (
            <View style={ st.list }>
                <ScrollView
                    showsHorizontalScrollIndicator={ false }
                    alwaysBounceVertical={ false }
                    horizontal={ true }
                    bounces={ false }
                    ref={ e => this.refs = e }
                >
                    {
                        issueList.map((item, index) => {
                            const info = item?.split(',');

                            return (
                                <JDTouchable onPress={ () => { this.changeDate(info[1], index); } } key={ index } style={ [st.dateView, (index == issueList.length - 1) && { marginRight: pt(5) }] }>
                                    <View style={ st.date }>
                                        <JDText style={ [st.dateTxt, info[1] == theDate && st.red] }>{info[0].slice(0, 2)}{info[1].slice(5)}</JDText>
                                        {info[2] == 'true' && <View style={ st.v_scale }><JDText style={ st.scale }>惠</JDText></View>}
                                    </View>
                                    {info[1] == theDate && <View style={ st.line } />}
                                </JDTouchable>
                            );
                        })
                    }
                </ScrollView>

            </View>
        );
    }

    componentDidMount() {
        const { issueList, theDate } = this.props;

        setTimeout(() => {
            issueList.forEach((item, inx) => {
                if (new RegExp(theDate, 'g').test(item) && inx > 3) {
                    if (inx >= (issueList.length - 2)) {
                        this.refs && this.refs.scrollToEnd();
                    } else {
                        this.refs && this.refs.scrollTo({ x: (pt(80 + 12) * (inx - 2)) + pt(15), y: 0, animated: true });
                    }
                }
            });
        }, 20);
    }

    // shouldComponentUpdate(nextProps){

    //     const { issueList, theDate, movieId } = this.props
    //     // if(nextProps.issueList!=issueList || nextProps.movieId!=movieId){
    //     //     setTimeout(()=>{
    //     //         issueList.forEach((item,inx) => {
    //     //             if(new RegExp(theDate,'g').test(item)){
    //     //                 if(this.refs.scroll)this.refs.scroll.scrollTo({x: 86*inx , y: 0, animated: true})
    //     //             }
    //     //         });
    //     //     },10)

    //     // }
    //     return true
    // }

    componentWillUnmount() {
        // if(this.refs.scroll)this.refs.scroll.scrollTo({x: 0 , y: 0, animated: true})
    }

    changeDate(info, index) {
        const { changeDate } = this.props;
        // if(info!=theDate){
        // if(this.refs.scroll)this.refs.scroll.scrollTo({x: 76*index , y: 0, animated: true})
        // }

        changeDate(info);
    }
}

const st = StyleSheet.create({
    // 列表样式
    list: {
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        paddingRight: 0,
        paddingBottom: 0,
        paddingTop: pt(5),
        height: pt(40),
        flexDirection: 'row',
        borderWidth: px(1),
        borderBottomColor: 'rgba(0, 0, 0, 0.1)',
        borderTopWidth: px(0)
    },
    dateView: {
        marginRight: pt(12),
        height: pt(40)
    },
    date: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: pt(33),
        width: pt(80)
    },
    red: {
        color: '#E2231A'
    },
    scale: {
        color: '#fff',
        fontSize: pt(10)
    },
    v_scale: {
        height: pt(14),
        width: pt(14),
        backgroundColor: '#F56A00',
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center'
    },
    line: {
        backgroundColor: '#E2231A',
        height: pt(2)
    }
});

module.exports = TabList;
